export const selectAvailableLanguages = state => state.language.available;

export const selectPreferredLanguage = state => state.language.preferred;

export const selectShowLanguageSelection = state =>
    !!(
        state.language.showLanguageSelection &&
        state.language.preferred &&
        state.language.available &&
        state.language.available.length > 0
    );

export const selectIsForeignLanguageActivated = state =>
    selectShowLanguageSelection(state) &&
    selectPreferredLanguage(state).languageCodeIso2 !== 'sv';

export const selectShowLanguageSelectionTooltip = state =>
    state.language.showTooltip;

export const selectShowLanguageSelectionOptoutTooltip = state =>
    state.language.showOptoutTooltip;

export const selectShouldAlwaysDisplayInMenu = state =>
    state.language.shouldAlwaysDisplayInMenu;

export const selectShouldDisplayInHeader = state =>
    state.language.shouldDisplayInHeader;
